import datas from './datas.json';

export default class DevisService {
    getAll() {
        return datas;
    }
}


// WEBPACK FOOTER //
// ./src/services/unites/UniteService.js